export default {

  ROLE_CUSTOMER: { id: 'CUSTOMER', name: 'Customer' },
  ROLE_BANK_ADMIN: { id: 'BANK_ADMIN', name: 'Bank Administrator' },
  ROLE_MERCHANT_ADMIN: { id: 'MERCHANT_ADMIN', name: 'Merchant Administrator' },
  ROLE_HELPDESK: { id: 'HELPDESK', name: 'Bank Operator' },
  ROLE_MERCHANT_OPERATOR: { id: 'MERCHANT_OPERATOR', name: 'Merchant Operator' },

  allRoles() {
    return [
      this.ROLE_CUSTOMER,
      this.ROLE_BANK_ADMIN,
      this.ROLE_MERCHANT_ADMIN,
      this.ROLE_HELPDESK,
      this.ROLE_MERCHANT_OPERATOR,
    ];
  },

  // Common permissions
  READ_MY_USER: 'READ_MY_USER',
  UPDATE_MY_USER: 'UPDATE_MY_USER',

  // Admin permissions
  READ_ANY_USER: 'READ_ANY_USER',
  UPDATE_ANY_USER: 'UPDATE_ANY_USER',
  CREATE_BO_USER: 'CREATE_BO_USER',
  CREATE_MC_USER: 'CREATE_MC_USER',
  READ_ANY_CUSTOMER: 'READ_ANY_CUSTOMER',
  UPDATE_ANY_CUSTOMER: 'UPDATE_ANY_CUSTOMER',
  READ_ANY_CARD: 'READ_ANY_CARD',
  UPDATE_ANY_CARD: 'UPDATE_ANY_CARD',
  READ_ANY_TRANSACTION: 'READ_ANY_TRANSACTION',
  UPDATE_ANY_TRANSACTION: 'UPDATE_ANY_TRANSACTION',
  READ_ANY_PURCHASE: 'READ_ANY_PURCHASE',
  UPDATE_ANY_PURCHASE: 'UPDATE_ANY_PURCHASE',
  READ_ANY_FINANCING_INSTITUTION: 'READ_ANY_FINANCING_INSTITUTION',
  UPDATE_ANY_FINANCING_INSTITUTION: 'UPDATE_ANY_FINANCING_INSTITUTION',
  CREATE_ANY_MERCHANT: 'CREATE_ANY_MERCHANT',
  READ_ANY_MERCHANT: 'READ_ANY_MERCHANT',
  UPDATE_ANY_MERCHANT: 'UPDATE_ANY_MERCHANT',
  READ_ANY_LOG: 'READ_ANY_LOG',
  READ_ANY_PERMISSION: 'READ_ANY_PERMISSION',
  CREATE_ANY_SETTING: 'CREATE_ANY_SETTING',
  READ_ANY_SETTING: 'READ_ANY_SETTING',
  UPDATE_ANY_SETTING: 'UPDATE_ANY_SETTING',
  DELETE_ANY_SETTING: 'DELETE_ANY_SETTING',
  READ_ANY_RULES_EVALUATION_RESULT: 'READ_ANY_RULES_EVALUATION_RESULT',
  READ_SCREENING: 'READ_SCREENING',
  READ_DELIVERY_METHODS: 'READ_DELIVERY_METHODS',
  UPDATE_DELIVERY_METHODS: 'UPDATE_DELIVERY_METHODS',

  // Merchant permissions
  READ_MERCHANT_PURCHASE: 'READ_MERCHANT_PURCHASE',
  UPDATE_MERCHANT_PURCHASE: 'UPDATE_MERCHANT_PURCHASE',
  READ_MERCHANT_TRANSACTION: 'READ_MERCHANT_TRANSACTION',
  UPDATE_MY_MERCHANT: 'UPDATE_MY_MERCHANT',
  READ_MERCHANT_EMPLOYEE: 'READ_MERCHANT_EMPLOYEE',
  UPDATE_MERCHANT_EMPLOYEE: 'UPDATE_MERCHANT_EMPLOYEE',
  READ_MERCHANT_WIDGET: 'READ_MERCHANT_WIDGET',
  CREATE_MERCHANT_WIDGET: 'CREATE_MERCHANT_WIDGET',
  UPDATE_MERCHANT_WIDGET: 'UPDATE_MERCHANT_WIDGET',
  READ_MERCHANT_CERTIFICATE: 'READ_MERCHANT_CERTIFICATE',
  READ_MERCHANT_ORDER: 'READ_MERCHANT_ORDER',
  UPDATE_MERCHANT_ORDER: 'UPDATE_MERCHANT_ORDER',
  READ_MERCHANT_SHIPPING_METHOD: 'READ_MERCHANT_SHIPPING_METHOD',
  CREATE_MERCHANT_SHIPPING_METHOD: 'CREATE_MERCHANT_SHIPPING_METHOD',
  UPDATE_MERCHANT_SHIPPING_METHOD: 'UPDATE_MERCHANT_SHIPPING_METHOD',

  toRoleName(roleId) {
    const role = this.findRoleById(roleId);
    return role ? role.name : undefined;
  },

  toRoleId(roleName) {
    const role = this.findRoleByName(roleName);
    return role ? role.id : undefined;
  },

  findRoleById(roleId) {
    return this.allRoles().find(role => role.id === roleId);
  },

  findRoleByName(roleName) {
    return this.allRoles().find(role => role.name === roleName);
  },

};



// WEBPACK FOOTER //
// ./src/utils/user-roles.js